import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  fill: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import colors from '../../colors';
import font from '../../font';
import { SVGStyled } from '../shared';
/**
 * Base SVG Text component
 *
 * @param props.fontSize number (equivalent to pixels), *scales relative to SVG dimensions*
 * @param props.fontWeight theme font.weight value
 * @param props.svgColor fill color (if not set, relies on value from context)
 */

var SVGText = SVGStyled.text(_templateObject(), colors.white, function (_ref) {
  var svgColor = _ref.svgColor,
      theme = _ref.theme;
  return svgColor || theme.svgColor;
}, function (_ref2) {
  var fontSize = _ref2.fontSize;
  return fontSize || 16;
}, function (_ref3) {
  var fontFamily = _ref3.fontFamily;
  return fontFamily || font.family["default"];
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight || font.weight.normal;
}, function (_ref5) {
  var lineHeight = _ref5.lineHeight;
  return lineHeight ? "line-height: ".concat(lineHeight, ";") : '';
});
export default SVGText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/svg/primitives/text.js
// module id = 1772
// module chunks = 12